import React, { Component } from 'react';
import { GMPicking } from './SOP/GMPicking';
import { SessionPrep } from './SOP/SessionPrep';
import { SessionSummary } from './SOP/SessionSummary';
import { Loader } from './Widgets/Loader';
import { Audio } from './Widgets/Audio';
import { DialogMessage } from './Widgets/DialogMessage';
import { SlotSummary } from './SOP/componentChildren/SlotSummary';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './css/Confirm.css';
import './css/SOP.css';
import { ItemStockInfo } from './SOP/componentChildren/ItemStockInfo';
import { ToteStorage } from './SOP/componentChildren/ToteStorage';
import { InvalidTotesInfo } from './SOP/componentChildren/InvalidTotesInfo';
import { SubItemInfo } from './SOP/componentChildren/SubItemInfo';
import { QtyEdit } from './SOP/componentChildren/QtyEdit';
import { OrderAction } from './SOP/componentChildren/OrderAction';

export class SOP extends Component {
    constructor(props) {
        if (props) {
            super(props);
        }
        this.state = {
            stage: 'Prep',
            userId: props.userId,
            userName: props.userName,
            userPermissions: props.userPermissions,
            appPermissions: props.appPermissions,
            batchId: '',
            versionNum: 0,
            badSession: false,
            requireSlotScan: false,
            multiScanThreshold: 20,
            putawayMode: false,
            verifyingSlot: false,
            SOPIds: [],
            SOPInfo: {},
            sessionTotes: [],
            invalidTotes: [],
            toteSoDict: {},
            locationOptionsDict: {},
            activeLocation: {},
            locationOptions: [],
            repickLocations: [],
            queues: [],
            sortByFields: [],
            orderActions: {},
            orderActionsIndex: -1,
            currentOrderAction: {},
            SOPWithToteDict: {},
            multipleSortBy: false,
            sortBy: "",
            additionalInfoOptions: {},
            repickList: [],
            shipGroups: [],
            toteStorageIds:[],
            sessionSummaryInfo: {},
            repickPutawayActive: false,
            completedRepicks: [],
            queue: '',
            repick: false,
            pickQty: 0,
            scannedToteInput: "",
            scannedItemInput: "",
            instructions: "Scan Totes, and begin",
            activeSlot: "",
            salesOrders: [],
            itemsToPick: [],
            nonFulfillableItems: [],
            scannedItemsCart: [],
            pickFromScannedItemsCart: false,
            activeZone: "",
            itemInfo: {},
            pickCounts: {
                picked: 0,
                backordered: 0,
                cancelled: 0,
                pickLater: 0
            },
            slotList: {},
            usedSlots: [],
            emptyBins: [],
            reverseSort: false,
            showDialog: false,
            isErrorMessage: false,
            actionDialog: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            summaryActive: false,
            loading: true,
            sucessfullySubmitted: false
        };
        this.stateUpdateInProgress = false;
        this.needToUpdateState = false;
        this.ToteRegex = new RegExp("^[0-9]*$");
        this.resetState = this.resetState.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.showConfirm = this.showConfirm.bind(this);
        this.updateInstructions = this.updateInstructions.bind(this);
        this.updateScanTote = this.updateScanTote.bind(this);
        this.updateScanItem = this.updateScanItem.bind(this);
        this.addScannedTote = this.addScannedTote.bind(this);
        this.addScannedToteCallback = this.addScannedToteCallback.bind(this);
        this.removeScannedTote = this.removeScannedTote.bind(this);
        this.removeAllScannedTotes = this.removeAllScannedTotes.bind(this);
        this.displayError = this.displayError.bind(this);
        this.changeImage = this.changeImage.bind(this);
        this.showImage = this.showImage.bind(this);
        this.processGMPickingInput = this.processGMPickingInput.bind(this);
        this.putAwayScannedItem = this.putAwayScannedItem.bind(this);
        this.setInvalidSlotScanEvent = this.setInvalidSlotScanEvent.bind(this);
        this.pickScannedItem = this.pickScannedItem.bind(this);
        this.subItem = this.subItem.bind(this);
        this.verifySlot = this.verifySlot.bind(this);
        this.pickItem = this.pickItem.bind(this);
        this.updateState = this.updateState.bind(this);
        this.updateStateCallback = this.updateStateCallback.bind(this);
        this.clearTotes = this.clearTotes.bind(this);
        this.submitTotes = this.submitTotes.bind(this);
        this.submitTotesCheckStatus = this.submitTotesCheckStatus.bind(this);
        this.submitTotesConfirmEmpty = this.submitTotesConfirmEmpty.bind(this);
        this.clearConfirmedTotes = this.clearConfirmedTotes.bind(this);
        this.submitTotesCallback = this.submitTotesCallback.bind(this);
        this.checkPutawayCart = this.checkPutawayCart.bind(this);
        this.submitPicking = this.submitPicking.bind(this);
        this.confirmBillAll = this.confirmBillAll.bind(this);
        this.submitPickingCallback = this.submitPickingCallback.bind(this);
        this.setupSummary = this.setupSummary.bind(this);
        this.putawayRepick = this.putawayRepick.bind(this);
        this.assignRepickToSlot = this.assignRepickToSlot.bind(this);
        this.repickPutawayBack = this.repickPutawayBack.bind(this);
        this.endSessionSummary = this.endSessionSummary.bind(this);
        this.updateLocation = this.updateLocation.bind(this);
        this.updateQueue = this.updateQueue.bind(this);
        this.changeRepick = this.changeRepick.bind(this);
        this.getBatchInfo = this.getBatchInfo.bind(this);
        this.confirmCancelBatch = this.confirmCancelBatch.bind(this);
        this.restoreSession = this.restoreSession.bind(this);
        this.cancelBatch = this.cancelBatch.bind(this);
        this.switchStage = this.switchStage.bind(this);
        this.pickNow = this.pickNow.bind(this);
        this.displayOrderAction = this.displayOrderAction.bind(this);
        this.doNotPick = this.doNotPick.bind(this);
        this.backorderItem = this.backorderItem.bind(this);
        this.backorderItemCallback = this.backorderItemCallback.bind(this);
        this.changeBin = this.changeBin.bind(this);
        this.changeBinCallback = this.changeBinCallback.bind(this);
        this.updateGiftCardNum = this.updateGiftCardNum.bind(this);
        this.addSerialNum = this.addSerialNum.bind(this);
        this.updateSerialNum = this.updateSerialNum.bind(this);
        this.editInputField = this.editInputField.bind(this);
        this.startBinQtyEdit = this.startBinQtyEdit.bind(this);
        this.updateQuantityWBins = this.updateQuantityWBins.bind(this);
        this.updateQuantity = this.updateQuantity.bind(this);
        this.changeZone = this.changeZone.bind(this);
        this.changePutawayMode = this.changePutawayMode.bind(this);
        this.sortItems = this.sortItems.bind(this);
        this.cancelItem = this.cancelItem.bind(this);
        this.cancelItemCallback = this.cancelItemCallback.bind(this);
        this.undoCancel = this.undoCancel.bind(this);
        this.undoBackorder = this.undoBackorder.bind(this);
        this.getSessionOptions = this.getSessionOptions.bind(this);
        this.cancelSessionConfirm = this.cancelSessionConfirm.bind(this);
        this.cancelSession = this.cancelSession.bind(this);
        this.undoPick = this.undoPick.bind(this);
        this.undoPickCallback = this.undoPickCallback.bind(this);
        this.startPutAway = this.startPutAway.bind(this);
        this.endPutAway = this.endPutAway.bind(this);
        this.flipOrder = this.flipOrder.bind(this);
        this.changeSortBy = this.changeSortBy.bind(this);
        this.toggleSortByLength = this.toggleSortByLength.bind(this);
        this.playFailure = this.playFailure.bind(this);
        this.playSuccess = this.playSuccess.bind(this);
        this.playScanSlot = this.playScanSlot.bind(this);
        this.playNeedMoreInfo = this.playNeedMoreInfo.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.startLoading = this.startLoading.bind(this);
        this.stopLoading = this.stopLoading.bind(this);
        this.getBatchInfo();
        this.getSessionOptions();
        
    }

    resetState() {
        this.setState({
            stage: 'Prep',
            batchId: '',
            versionNum: 0,
            badSession: false,
            requireSlotScan: false,
            multiScanThreshold: 20,
            putawayMode: false,
            verifyingSlot: false,
            SOPIds: [],
            SOPInfo: {},
            sessionTotes: [],
            invalidTotes: [],
            toteSoDict: {},
            locationOptionsDict: {},
            activeLocation: {},
            locationOptions: [],
            repickLocations: [],
            queues: [],
            sortByFields: [],
            orderActions: {},
            orderActionsIndex: -1,
            currentOrderAction: {},
            SOPWithToteDict: {},
            multipleSortBy: false,
            sortBy: "",
            additionalInfoOptions: {},
            repickList: [],
            shipGroups: [],
            toteStorageIds: [],
            sessionSummaryInfo: {},
            repickPutawayActive: false,
            completedRepicks: [],
            queue: '',
            repick: false,
            pickQty: 0,
            scannedToteInput: "",
            scannedItemInput: "",
            instructions: "Scan Totes, and begin",
            activeSlot: "",
            salesOrders: [],
            itemsToPick: [],
            nonFulfillableItems: [],
            scannedItemsCart: [],
            pickFromScannedItemsCart: false,
            activeZone: "",
            itemInfo: {},
            pickCounts: {
                picked: 0,
                backordered: 0,
                cancelled: 0,
                pickLater: 0
            },
            slotList: {},
            usedSlots: [],
            emptyBins: [],
            reverseSort: false,
            showDialog: false,
            isErrorMessage: false,
            actionDialog: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            summaryActive: false,
            loading: true,
            sucessfullySubmitted: false
        });
        this.stateUpdateInProgress = false;
        this.needToUpdateState = false;
        this.getSessionOptions();
        
    }

    focusOnInput() {
        var scanInput = document.getElementById("scanInput");
        var confirmActive = document.getElementsByClassName("react-confirm-alert-body").length > 0;
        if (scanInput && !this.state.showDialog && !confirmActive) {
            scanInput.focus();
        }
    }

    showConfirm(title, message, buttonTextPositive, buttonTextNegative, positiveFunction, negativeFunction, hideSubmit=false) {
        var buttons = [{
            label: buttonTextNegative,
            onClick: negativeFunction
        }];
        if (!hideSubmit) {
            buttons.push({
                label: buttonTextPositive,
                onClick: positiveFunction
            });
        }

        const options = {
            title: title,
            message: message,
            buttons: buttons,
            childrenElement: () => <div/>,
            closeOnEscape: false,
            closeOnClickOutside: false,
            willUnmount: () => { },
            afterClose: () => { },
            onClickOutside: () => { },
            onKeypressEscape: () => { },
            overlayClassName: "confirm-message"
        };

        confirmAlert(options);
    }

    updateInstructions(newInstructions, activeSlot = "") {
        if (this.state.requireSlotScan && !this.state.putawayMode) {
            activeSlot = "";
        }
        this.setState({
            instructions: newInstructions,
            activeSlot: activeSlot
        });
        this.focusOnInput();
    }

    updateScanTote(value) {
        this.setState({
            scannedToteInput: value.toUpperCase()
        });
        this.focusOnInput();
    }

    updateScanItem(value) {
        this.setState({
            scannedItemInput: value.toUpperCase()
        });
        this.focusOnInput();
    }

    addScannedTote(e) {
        e.preventDefault();
        var scannedInput = this.state.scannedToteInput.trim();
        if (!scannedInput) {
            return;
        }
        var instructions = "";
        if (
            this.ToteRegex.test(scannedInput)
            &&
            this.state.sessionTotes.indexOf(scannedInput) === -1
        ) {
            this.setState({
                showDialog: true,
                dialogFullScreen: false,
                dialogContent: (<form className="slotInput" onSubmit={(e) => this.addScannedToteCallback(e)} >
                    <label htmlFor="slotNum"></label>
                    <input
                        autoFocus
                        required
                        pattern='[Ss]lot-.*'
                        autoComplete="off"
                        type="text"
                        id="slotNum"
                        name="slotNum"
                    />
                </form>),
                dialogTitle: "Scan Slot Number",
                isErrorMessage: false,
                actionDialog: true,
                summaryActive: false
            });
        }
        else {
            this.playFailure();
            var errorMessage = " is not a valid Tote";
            if (this.state.sessionTotes.indexOf(scannedInput)  !== -1) {
                errorMessage = " is already in the list";
            }
            instructions = scannedInput + errorMessage
            this.setState({
                scannedToteInput: "",
                instructions: instructions
            });
            this.focusOnInput();
        }
    }

    addScannedToteCallback(e) {
        e.preventDefault();
        var slotNum = e.target.elements.slotNum.value;
        var usedSlots = this.state.usedSlots;
        //Insure S is capitalized
        slotNum = slotNum[0].toUpperCase() + slotNum.slice(1);
        if (usedSlots.indexOf(slotNum) == -1) {
            usedSlots.push(slotNum);
            var sessionTotes = this.state.sessionTotes;
            var slotList = this.state.slotList;
            var scannedInput = this.state.scannedToteInput.trim();
            sessionTotes.push(scannedInput);
            slotList[scannedInput] = slotNum;
            this.playSuccess();
            var instructions = scannedInput + " added to the list";
            this.setState({
                scannedToteInput: "",
                showDialog: false,
                dialogContent: "",
                instructions: instructions,
                sessionTotes: sessionTotes,
                slotList: slotList,
                usedSlots: usedSlots
            });
            this.focusOnInput();
        } else {
            this.playFailure();
            var errorMessage = slotNum + " has already been used";
            this.setState({
                scannedToteInput: "",
                instructions: errorMessage,
                dialogContent: "",
                showDialog: ""
            });
            this.focusOnInput();
        }
        
    }

    removeScannedTote(toteId) {
        var sessionTotes = this.state.sessionTotes;
        var slotList = this.state.slotList;
        var usedSlots = this.state.usedSlots;
        var index = sessionTotes.indexOf(toteId);
        if (index > -1) {
            sessionTotes.splice(index, 1);
            var slot = slotList[toteId];
            var slotIndex = usedSlots.indexOf(slot);
            if (slotIndex > -1) {
                usedSlots.splice(index, 1);
            }
            delete slotList[toteId]
        }
        this.setState({
            sessionTotes: sessionTotes,
            slotList: slotList
        });
        this.updateInstructions(toteId + " has been removed");
        this.focusOnInput();
    }

    removeAllScannedTotes() {
        this.setState({
            sessionTotes: [],
            usedSlots: [],
            slotList: {},
            instructions: "Scan Totes, and begin"
        });
        this.focusOnInput();
    }

    displayError(title, message) {
        this.setState({
            dialogContent: message,
            dialogTitle: title,
            showDialog: true,
            isErrorMessage: true,
            actionDialog: false
        });
    }

    changeImage(itemId) {
        var itemInfo = this.state.itemInfo;
        var imageURLLength = itemInfo[itemId].imageURLs.length;
        var newImageIndex = itemInfo[itemId].imageIndex;
        newImageIndex = newImageIndex + 1;
        if (newImageIndex === imageURLLength) {
            newImageIndex = 0;
        }
        itemInfo[itemId].imageIndex = newImageIndex;
        var newImageURL = itemInfo[itemId].imageURLs[newImageIndex];
        var imageContent = (
            <div>
                <img alt="Not Available" src={newImageURL} width="300" height="300" />
                <button onClick={() => this.changeImage(itemId)}>Next Image</button>
            </div>
        )
        this.setState({
            itemInfo: itemInfo,
            dialogContent: imageContent
        });
    }


    showImage(itemId) {
        var itemInfo = this.state.itemInfo;
        var imageURLs = itemInfo[itemId].imageURLs;
        var imageIndex = itemInfo[itemId].imageIndex;
        var hasMultipleImages = imageURLs.length > 1;
        var imageContent = (
            <div>
                <img alt="Not Available" src={imageURLs[imageIndex]} width="300" height="300" />
                {hasMultipleImages && <button onClick={() => this.changeImage(itemId)}>Next Image</button>}
            </div>
       )
        this.setState({
            dialogContent: imageContent,
            dialogTitle: "",
            showDialog: true,
            dialogFullScreen: true
        });
    }

    updateState() {
        console.log("UPDATING STATE");
        if (this.state.stage == "Picking" && !this.state.sucessfullySubmitted) {
            setTimeout(this.updateStateCallback, 3000);
        }
    }

    async updateStateCallback() {
        if (this.stateUpdateInProgress) {
            this.needToUpdateState = true;
            return;
        }
        else {
            this.stateUpdateInProgress = true;
        }
        var currState = this.state;
        //needToUpdateState
        var postBody = {
            batchId: this.state.batchId,
            state: JSON.stringify(currState),
            versionNum: this.state.versionNum
        };
        await this.props.makeRESTCall(
            'byusopstate',
            'post',
            postBody,
            (updateBatchStatusInfo) => {
                if (this.state.stage !== "Picking" || this.state.sucessfullySubmitted) {
                    //They are no longer picking
                    return;
                }
                if (updateBatchStatusInfo.success) {
                    this.stateUpdateInProgress = false;
                    if (this.needToUpdateState) {
                        this.updateState();
                    }
                    this.setState({
                        versionNum: updateBatchStatusInfo.versionNum
                    });
                    this.needToUpdateState = false;
                }
                else {
                    var errMessage;
                    if (updateBatchStatusInfo.badBatchState) {
                        errMessage =  "The Picking Session has Entered a Bad State and Cannot be Continued. Please Contact IT";
                    }
                    else {
                        errMessage = "It appears that this picking session is open on more then one device/page and they are out of sync. To prevent lost work, please refresh this session or close and continue with a single session."
                    }
                    this.setState({
                        badSession: true,
                        showDialog: true,
                        dialogTitle: "Session in a Bad State",
                        dialogContent: errMessage,
                        isErrorMessage: true,
                        actionDialog: false
                    });
                }
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                this.stopLoading();
            }
        );
    }

    async clearTotes(modifySOP, toteIds) {
        var result = {};
        //needToUpdateState
        var postBody = {
            toteIdsToClear: toteIds,
            modifySOP: modifySOP
        };

        await this.props.makeRESTCall(
            'byusopcheckncleartotes',
            'post',
            postBody,
            (clearEmptyTotesInfo) => {
                result = clearEmptyTotesInfo;
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
            }
        );
        return result;
    }

    processGMPickingInput(e) {
        e.preventDefault();
        if (this.state.pickFromScannedItemsCart) {
            this.putAwayScannedItem();
        } else {
            this.pickScannedItem();
        }
    }

    putAwayScannedItem(slotVerified = !this.state.requireSlotScan) {
        console.log("SLOT VERIFIED", slotVerified);
        var scannedItem = this.state.scannedItemInput.toString().trim();
        var scannedItemsCart = this.state.scannedItemsCart;
        var foundItem = false;
        var itemIndex;
        var itemInCart;
        for (var i in scannedItemsCart) {
            itemInCart = scannedItemsCart[i];
            if (itemInCart.identifier == scannedItem) {
                itemIndex = i;
                foundItem = true;
                break;
            }
        }
        if (!foundItem) {
            this.updateInstructions(scannedItem + " is invalid");
            this.setState({
                scannedItemInput: ""
            });
            this.playFailure();
        }
        else if (slotVerified) {
            this.updateInstructions(itemInCart.item, itemInCart.slot);
            scannedItemsCart.splice(itemIndex, 1);
            this.playSuccess();
            this.setState({
                scannedItemInput: "",
                scannedItemsCart: scannedItemsCart
            });
            this.updateState();
            this.focusOnInput();
        }
        else {
            this.playScanSlot();
            this.setState({
                verifyingSlot: true,
                showDialog: true,
                dialogFullScreen: true,
                dialogContent: (
                    <div>
                        <form className="verifySlot" onSubmit={(e) => { e.preventDefault(); this.closeDialog(true); this.putAwayScannedItem(true) }} >
                            <label htmlFor="slotNum"></label>
                            <input
                                autoFocus
                                required
                                pattern={itemInCart.tote}
                                autoComplete="off"
                                type="text"
                                id="slotNum"
                                name="slotNum"
                            />                          
                        </form>
                        <b>Tote: {itemInCart.tote}</b>
                    </div>
                ),
                dialogTitle: "Scan Tote In " + itemInCart.slot,
                isErrorMessage: false,
                actionDialog: true,
                summaryActive: false
            });
            setTimeout(this.setInvalidSlotScanEvent, 10);
        }
    }

    setInvalidSlotScanEvent() {
        var slotInput = document.getElementById("slotNum");
        slotInput.oninvalid = (event) => {
            console.log("IS VALID", event.target.validity.valid);
            if(!event.target.validity.valid) {
                console.log("EVENT", event);
                var audioElbadISBN = document.getElementsByClassName("audio-element-failure")[0];
                if (audioElbadISBN.paused) {
                    audioElbadISBN.play();
                } else {
                    audioElbadISBN.currentTime = 0
                }
                var slotInput = document.getElementById("slotNum");
                slotInput.value = "";
            }
        }
    }

    pickScannedItem(e) {
        var foundItem = false;
        var itemIndex;
        var usedBin;
        var locationUsesBins = this.state.activeLocation.usesBins;
        var itemsToPick = this.state.itemsToPick;
        var scannedItem = this.state.scannedItemInput.toString().trim();
        var instructions = "";
        if (locationUsesBins && !this.state.activeZone) {
            this.setState({
                scannedItemInput: ""
            });
            instructions = "Please select a zone to pick in";
            this.updateInstructions(instructions);
            this.playFailure();
            return;
        }
        var itemToPick;
        for (var i in itemsToPick) {
            itemToPick = itemsToPick[i];
            var itemId = itemToPick.itemId;
            var itemInfo = this.state.itemInfo[itemId];
            var binIndex = itemInfo.binIndex;
            usedBin = itemInfo.bins[binIndex].binId;
            var zone = itemInfo.bins[binIndex].pickingOrder;
            if (
                (
                    !locationUsesBins
                    ||
                    zone === this.state.activeZone
                )
                &&
                itemInfo.identifiers.indexOf(scannedItem) > -1
                &&
                itemToPick.quantity > 0
            ) {
                //They cannot pick more then we have listed in the bin
                var binQty = itemInfo.bins[binIndex].onHand;
                if (locationUsesBins && usedBin != "none" && binQty == 0) {
                    var binName = itemInfo.bins[binIndex].bin;
                    this.setState({
                        scannedItemInput: "",
                        showDialog: true,
                        dialogFullScreen: false,
                        dialogTitle: binName + " is empty",
                        dialogContent: "You have picked the maximum qty of items from this bin and it is now empty. If you believe this is in error, check your count.",
                        isErrorMessage: true,
                        actionDialog: false,
                        summaryActive: false
                    });
                    instructions = binName + " is empty";
                    this.updateInstructions(instructions);
                    this.playFailure();
                    return;
                }
                else {
                    foundItem = true;
                    itemIndex = i;
                    break;
                }
            }
        }
        if (!foundItem) {
            if (!locationUsesBins) {
                var itemToPick;
                for (var i in itemsToPick) {
                    itemToPick = itemsToPick[i];
                    if (itemToPick.allowSubstitution) {
                        if (itemToPick.quantity > 0) {
                            var itemId = itemToPick.itemId;
                            var itemInfo = this.state.itemInfo[itemId];
                            var substitutionIdDict = itemInfo.substitutionIds;
                            for (var subId in substitutionIdDict) {
                                if (subId == scannedItem) {
                                    if ((itemToPick.quantity + itemToPick.quantityPicked) > 1) {
                                        this.setState({
                                            scannedItemInput: ""
                                        });
                                        instructions = "Substitution is Currently Unavailable for QTYS greater then 1. You may modify the SO to have multiple lines of QTY 1";
                                        this.updateInstructions(instructions);
                                        this.playFailure();
                                    }
                                    else {
                                        var subItemInfo = substitutionIdDict[subId];
                                        document.activeElement.blur();
                                        this.playNeedMoreInfo();
                                        this.showConfirm(
                                            "Sub Item",
                                            <SubItemInfo
                                                oldItem={itemInfo}
                                                newItem={subItemInfo}
                                            />,
                                            "Don't Sub",
                                            "Yes",
                                            () => { this.subItem(false, subItemInfo, itemsToPick, itemToPick, i, false, scannedItem, "none") },
                                            () => { this.subItem(true, subItemInfo, itemsToPick, itemToPick, i, false, scannedItem, "none") }
                                        );
                                    }
                                    //Bail Out
                                    return;
                                }
                            }
                        }
                    }
                }
            }
            this.setState({
                scannedItemInput: ""
            });
            instructions = scannedItem + " is invalid";
            this.updateInstructions(instructions);
            this.playFailure();
        }
        else if(locationUsesBins && itemToPick.usesBins && usedBin == "none") {
            this.setState({
                scannedItemInput: "",
                showDialog: true,
                dialogFullScreen: false,
                dialogTitle: "Item Not Fulfillable in the Warehouse",
                dialogContent: "This scanned item is not found in any bin in the warehouse, and cannot be fulfilled here",
                isErrorMessage: true,
                actionDialog: false,
                summaryActive: false
            });
            instructions = scannedItem + " is not fulfillable here";
            this.updateInstructions(instructions);
            this.playFailure();
        }
        else if (itemToPick.needsSerialNum && !itemToPick.serialNum) {
            this.playNeedMoreInfo();
            this.setState({
                showDialog: true,
                dialogFullScreen: false,
                dialogContent: (<form className="serialInput" onSubmit={(e) => this.addSerialNum(e, itemsToPick, itemToPick, itemIndex, locationUsesBins, scannedItem, usedBin)} >
                    <label htmlFor="serialNum">{this.state.additionalInfoOptions['serialNum'].promptText}: </label>
                    <input
                        autoFocus
                        required
                        pattern={this.state.additionalInfoOptions['serialNum'].regex}
                        autoComplete="off"
                        type="text"
                        id="serialNum"
                        name="serialNum"
                    />
                </form>),
                dialogTitle: "Input Serial Number",
                isErrorMessage: false,
                actionDialog: true,
                summaryActive: false
            });
            this.updateState();
        } else {
            if (this.state.requireSlotScan && this.state.putawayMode) {
                this.verifySlot(itemsToPick, itemToPick, itemIndex, locationUsesBins, scannedItem, usedBin);
            }
            else {
                this.pickItem(itemsToPick, itemToPick, itemIndex, locationUsesBins, scannedItem, usedBin);
            }  
        }
    }


    subItem(doSubstitution, subItemInfo, itemsToPick, itemToPick, itemIndex, locationUsesBins, scannedItem, usedBin) {
        if (doSubstitution) {
            if (this.state.requireSlotScan && this.state.putawayMode) {
                this.verifySlot(itemsToPick, itemToPick, itemIndex, locationUsesBins, scannedItem, usedBin, subItemInfo);
            }
            else {
                this.pickItem(itemsToPick, itemToPick, itemIndex, locationUsesBins, scannedItem, usedBin, subItemInfo);
            }
        }
        else {
            this.setState({
                scannedItemInput: ""
            });
            var instructions = "You have Canceled Substitution";
            this.updateInstructions(instructions);
            this.playFailure();
        }
    }

    verifySlot(itemsToPick, itemToPick, index, locationUsesBins, scannedItem, usedBin, subItemInfo=null) {
        this.playScanSlot();
        var itemInfo = this.state.itemInfo[itemToPick.itemId];
        var binIndex = itemInfo.binIndex;
        var binText = itemInfo.bins[binIndex].bin;
        this.setState({
            verifyingSlot: true,
            showDialog: true,
            dialogFullScreen: true,
            dialogContent: (
                <div>
                    <form className="verifySlot" onSubmit={(e) => { e.preventDefault(); this.closeDialog(true); this.pickItem(itemsToPick, itemToPick, index, locationUsesBins, scannedItem, usedBin, subItemInfo) }} >
                        <label htmlFor="slotNum"></label>
                        <input
                            autoFocus
                            required
                            pattern={itemToPick.tote}
                            autoComplete="off"
                            type="text"
                            id="slotNum"
                            name="slotNum"
                        />
                    </form>
                    <button className="putawayModeButton" onClick={() => {
                        this.setState({
                            putawayMode: false,
                            showDialog: false
                        });
                        this.state.scannedItemsCart.push({
                            item: itemToPick.itemName,
                            slot: itemToPick.slot,
                            identifier: scannedItem,
                            subItemInfo: subItemInfo,
                            tote: itemToPick.tote,
                            itemId: itemToPick.itemId,
                            usedBin: usedBin,
                            binText: binText
                        });
                        this.pickItem(itemsToPick, itemToPick, index, locationUsesBins, scannedItem, usedBin);
                    }}>Putaway Items Later</button>
                    <b>Tote: {itemToPick.tote}</b>
                </div>
            ),
            dialogTitle: "Scan Tote In " + itemToPick.slot,
            isErrorMessage: false,
            actionDialog: true,
            summaryActive: false
        });
        setTimeout(this.setInvalidSlotScanEvent, 10);
    }

    pickItem(itemsToPick, itemToPick, index, locationUsesBins, scannedItem, usedBin, subItemInfo = null) {
        console.log("ITEM TO PICK", itemToPick);
        var itemSlot = itemToPick.slot;
        var itemName = itemToPick.itemName;
        var tote = itemToPick.tote;
        itemToPick.quantity = itemToPick.quantity - 1;
        itemToPick.quantityPicked = itemToPick.quantityPicked + 1;
        itemToPick.subItemInfo = subItemInfo;
        itemToPick.doSubstitution = subItemInfo != null;
        var itemInfo = this.state.itemInfo[itemToPick.itemId];
        var binIndex = itemInfo.binIndex;
        var binText = itemInfo.bins[binIndex].bin;
        if (locationUsesBins) {
            if (!itemToPick.usedBins[usedBin]) {
                itemToPick.usedBins[usedBin] = {
                    binId: usedBin,
                    qty: 0,
                    binText: binText
                }
            }
            var previousBinQty = itemToPick.usedBins[usedBin].qty;
            itemToPick.usedBins[usedBin].qty = previousBinQty + 1;
            itemToPick.subItemInfo = subItemInfo;
            //Decrease on hand value
            var itemInfo = this.state.itemInfo;
            var pickedItemInfo = itemInfo[itemToPick.itemId];
            var prevBinQty = pickedItemInfo.bins[pickedItemInfo.binIndex].onHand;
            itemInfo[itemToPick.itemId].bins[pickedItemInfo.binIndex].onHand = prevBinQty - 1;
            this.setState({
                itemInfo: itemInfo
            });
        }
        itemsToPick[index] = itemToPick;
        if (subItemInfo) {
            itemName = "*SUB* " + subItemInfo.displayName + " *SUB*";
        }
        
        this.updateInstructions(itemName, itemSlot);
        if (!this.state.putawayMode) {
            this.state.scannedItemsCart.push({
                item: itemName,
                slot: itemSlot,
                identifier: scannedItem,
                subItemInfo: subItemInfo,
                itemId: itemToPick.itemId,
                tote: tote,
                usedBin: usedBin,
                binText: binText
            });
        }
        //Move item to the bottom of the list
        if (itemToPick.quantity == 0) {
            itemsToPick.splice(index, 1);
            itemsToPick.push(itemToPick);
        }
        var pickCounts = this.state.pickCounts;
        pickCounts.picked = pickCounts.picked + 1;
        if (itemToPick.pickLater) {
            pickCounts.pickLater = pickCounts.pickLater - 1;
        }
        this.setState({
            itemsToPick: itemsToPick,
            scannedItemInput: "",
            pickCounts: pickCounts
        });
        this.playSuccess();
        this.focusOnInput();
        this.updateState();
    }

    submitTotes() {
        if (!this.state.activeLocation.locationId) {
            alert("Please select a location");
        }
        else if (this.state.sessionTotes.length == 0) {
            alert("Please Scan a Tote");
        }
        else if (!this.state.queue.id && !this.state.repick) {
            alert("Please Select a Queue to pick from");
        }
        else {
            this.startLoading();
            if (this.state.repick) {
                this.submitTotesCallback();
            } else {
                this.submitTotesCheckStatus();
            }
        }
    }

    async submitTotesCheckStatus() {
        await this.props.makeRESTCall(
            'byusopcheckncleartotes?toteIds=' + this.state.sessionTotes.toString(),
            'get',
            null,
            (checkTotesStatusInfo) => {
                if (checkTotesStatusInfo.success) {
                    var emptyToteIds = checkTotesStatusInfo.emptyToteIds;
                    var totesToConfirm = checkTotesStatusInfo.totesToConfirm;
                    var totesUnableToClear = checkTotesStatusInfo.totesUnableToClear;
                    this.submitTotesConfirmEmpty(totesToConfirm, totesUnableToClear, []);
                } else {
                    this.removeAllScannedTotes();
                    this.stopLoading();
                    this.displayError("There was an error validating your totes, Please contact I.T.", checkTotesStatusInfo.message);
                }
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                
            }
        );
    }

    submitTotesConfirmEmpty(totesToConfirm, totesUnableToClear, totesToClear) {
        var hasInvalidTotes = false;
        for (var i in totesUnableToClear) {
            hasInvalidTotes = true;
            break;
        }
        if (totesToConfirm.length > 0) {
            this.stopLoading();
            var toteToConfirm = totesToConfirm.shift();
            this.showConfirm(
                "Confirm Tote Status",
                "Is Tote " + toteToConfirm.toteId + " empty?",
                "Yes",
                "No",
                () => setTimeout(() => this.submitTotesConfirmEmpty(totesToConfirm, totesUnableToClear, totesToClear.concat([toteToConfirm.toteId])),100),
                () => setTimeout(() => this.submitTotesConfirmEmpty(totesToConfirm, totesUnableToClear.concat([toteToConfirm]), totesToClear),100)
            )
        }
        else if (hasInvalidTotes) {
            this.stopLoading();
            var slotList = this.state.slotList;
            for (var i in totesUnableToClear) {
                totesUnableToClear[i].slot = slotList[totesUnableToClear[i].toteId];
            }
            this.showConfirm(
                "Invalid Totes",
                < InvalidTotesInfo
                    invalidTotes={totesUnableToClear}
                />,
                "OK",
                "OK",
                () => this.clearConfirmedTotes(totesToClear, true),
                () => this.clearConfirmedTotes(totesToClear, true),
                true
            )
            this.removeAllScannedTotes();
        }
        else {
            this.clearConfirmedTotes(totesToClear)
        }
    }

    async clearConfirmedTotes(totesToClear, hasInvalid = false) {
        this.startLoading();
        var totesClearedInfo = await this.clearTotes(true, totesToClear);
        if (totesClearedInfo.success) {
            if (!hasInvalid) {
                this.submitTotesCallback();
            }
            else {
                this.stopLoading();
            }
        }
        else {
            this.setState({
                showDialog: true,
                dialogTitle: "There was an error validating your totes, Please contact IT",
                dialogContent: totesClearedInfo.message,
                isErrorMessage: true,
                actionDialog: false,
                batchId: "",
                instructions: "Scan Totes, and begin",
                sessionTotes: [],
                usedSlots: [],
                loading: false
            });
        }
        this.focusOnInput();
    }

    async submitTotesCallback() {
        this.startLoading();
        if (this.state.sessionTotes.length > 0) {
            var queueId = this.state.queue.id;
            if (!queueId) {
                queueId = "0";
            }
            await this.props.makeRESTCall(
                'byuwmssop?toteList=' + this.state.sessionTotes.toString() + '&userId=' + this.state.userId + '&queueId=' + queueId + '&repick=' + this.state.repick,
                'get',
                null,
                (startPickingSessionInfo) => {
                    if (startPickingSessionInfo.success) {
                        if (!this.state.repick && !startPickingSessionInfo.queueAvailable) {
                            this.setState({
                                showDialog: true,
                                dialogTitle: "Queue Currently Unavailable",
                                dialogContent: "The Queue is currently busy generating another session. Please try again!",
                                isErrorMessage: false,
                                actionDialog: false
                            });
                        }
                        else {
                            var slotList = this.state.slotList;
                            var invalidTotes = startPickingSessionInfo.invalidTotes;
                            var invalidTotesArray = [];
                            for (var key in invalidTotes) {
                                invalidTotesArray.push({
                                    tote: key,
                                    message: invalidTotes[key]
                                });
                                delete slotList[key];
                            }
                            if (!startPickingSessionInfo.batchId) {
                                var invalidTotesContent = (
                                    <div>
                                        {
                                            (invalidTotesArray && invalidTotesArray.length > 0) &&
                                            <div>
                                                <h2> Invalid Totes </h2>
                                                {
                                                    invalidTotesArray.map(function (invalidTote, idx) {
                                                        return (
                                                            <div key={idx}>
                                                                <h3>{invalidTote.tote} : {invalidTote.message}</h3>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        }
                                        <br />
                                        <br />
                                    </div>
                                );
                                this.setState({
                                    showDialog: true,
                                    dialogTitle: "All Scanned Totes were Invalid",
                                    dialogContent: invalidTotesContent,
                                    isErrorMessage: false,
                                    actionDialog: false,
                                    batchId: "",
                                    instructions: "Scan Totes, and begin",
                                    sessionTotes: [],
                                    usedSlots: []
                                });
                                if (this.state.batchId) {
                                    this.cancelBatch();
                                }
                            }
                            else {
                                var itemsToPick = startPickingSessionInfo.itemsToPick;
                                var validTotes = [];
                                //Keep them in the same order they scanned them
                                if (this.state.sessionTotes.length > 0) {
                                    validTotes = this.state.sessionTotes.filter(function (el) {
                                        return !invalidTotes[el];
                                    });
                                }
                                var SOPIds = startPickingSessionInfo.SOPIds;
                                //Assign each SOP a slot
                                for (var i in itemsToPick) {
                                    var sopId = itemsToPick[i].sopId;
                                    var orderTote = startPickingSessionInfo.SOPWithToteDict[sopId];
                                    itemsToPick[i].slot = slotList[orderTote];
                                    itemsToPick[i].tote = orderTote;
                                }
                                var itemInfo = startPickingSessionInfo.itemInfo;
                                var sortByFields = startPickingSessionInfo.sortByFields;
                                var orderActions = startPickingSessionInfo.orderActions;
                                var defaultSortBy = sortByFields[0];
                                console.log("ITEM INFO",itemInfo)
                                this.setState({
                                    itemsToPick: this.sortItems(itemsToPick, itemInfo, defaultSortBy),
                                    itemInfo: itemInfo,
                                    batchId: startPickingSessionInfo.batchId,
                                    invalidTotes: invalidTotesArray,
                                    nonFulfillableItems: startPickingSessionInfo.nonFulfillableItems,
                                    SOPWithToteDict: startPickingSessionInfo.SOPWithToteDict,
                                    instructions: 'Scan an Item',
                                    sessionTotes: validTotes,
                                    slotList: slotList,
                                    SOPIds: SOPIds,
                                    SOPInfo: startPickingSessionInfo.SOPInfo,
                                    sortByFields: sortByFields,
                                    orderActions: orderActions,
                                    sortBy: defaultSortBy,
                                    multipleSortBy: sortByFields.length > 1
                                });
                                this.switchStage('Picking');
                            }
                        }
                    }
                    else {
                        this.displayError("Error Starting Session", startPickingSessionInfo.message);
                        if (this.state.batchId) {
                            this.cancelBatch();
                        }
                        this.setState({
                            batchId: "",
                            instructions: "Scan Totes, and begin"
                        });
                    }
                },
                (title, error) => {
                    this.displayError(title, error);
                },
                () => {
                    this.stopLoading();
                }
            );
        } else {
            alert("YOU NEED TO ADD TOTES")
        }
        this.focusOnInput();
        this.stopLoading();
    }

    checkPutawayCart() {
        if (this.state.scannedItemsCart.length > 0) {
            var buttonText1, buttonText2, buttonFunction1, buttonFunction2;
            if (this.state.requireSlotScan) {
                buttonText1 = "Put Items Away";
                buttonText2 = "Put Items Away";
                buttonFunction1 = () => this.focusOnInput();
                buttonFunction2 = () => this.focusOnInput();
            }
            else {
                buttonText1 = "Put Items Away";
                buttonText2 = "Ready To Submit";
                buttonFunction1 = () => this.focusOnInput();
                buttonFunction2 = () => setTimeout(this.submitPicking, 10)
            }
            this.showConfirm(
                "Items Left to Put Away",
                "Please insure that all items are placed in the correct Totes before submitting!",
                buttonText1,
                buttonText2,
                buttonFunction1,
                buttonFunction2,
                this.state.requireSlotScan
            );
        }
        else {
            this.submitPicking();
        }
    }

    submitPicking() {
        this.setState({
            sucessfullySubmitted: true
        })
        var itemsToPick = this.state.itemsToPick;
        var allItemsComplete = true;
        var allItemsFulfilled = true;
        var additionalInfoNotSubmitted = false;
        var SOPsToBill = JSON.parse(JSON.stringify(this.state.SOPIds));
        for (var i in itemsToPick) {
            var item = itemsToPick[i];
            if (item.quantity > 0) {
                allItemsFulfilled = false;
                var soIndex = SOPsToBill.indexOf(item.sopId);
                if (soIndex > -1) {
                    SOPsToBill.splice(soIndex, 1);
                }
                if (!item.pickLater) {
                    allItemsComplete = false;
                    break;
                }
            }
            else if(
                    (item.isGiftCard && (item.editGiftCard || !item.giftCardNum))
                    ||
                    (item.needsSerialNum && (item.editSerialNum || !item.serialNum))
            ) {
                additionalInfoNotSubmitted = true;
            }
        }
        if (!allItemsComplete) {
            this.setState({
                showDialog: true,
                dialogTitle: "Not ready to submit",
                dialogContent: "There are some items that still haven't been fulfilled, backordered, or marked for picking later. Please account for every item and then submit",
                isErrorMessage: false,
                actionDialog: false
            });
        }
        else if (additionalInfoNotSubmitted) {
            this.setState({
                showDialog: true,
                dialogTitle: "Not ready to submit",
                dialogContent: "There are some items that still have additional info that needs to be submitted. If you edited the field, hit enter to submit it.",
                isErrorMessage: false,
                actionDialog: false
            });
        }
        else {
            this.submitPickingCallback(SOPsToBill);
        }
    }

    confirmBillAll(SOPsToBill) {
        this.showConfirm(
            "Are You Sure About Billing?",
            "Are you sure you want to bill all orders? This will result in multiple shipments.",
            "Finish Picking Later",
            "Bill and Ship Incomplete Orders",
            () => this.submitPickingCallback(SOPsToBill),
            () => this.submitPickingCallback(this.state.SOPIds)
        );
    }

    async submitPickingCallback(SOPsToBill) {
        this.startLoading();
        var itemsToPick = this.state.itemsToPick;
        var pickingSummary = {};
        var SOPIds = this.state.SOPIds;
        for (var i in SOPIds) {
            pickingSummary[SOPIds[i]] = [];
        }
        var pickingSummaryArray = [];
        var additionalInfo = {};
        for (var i in itemsToPick) {
            var item = itemsToPick[i];
            var qty = item.quantityPicked;
            var lineUniqueId = item.lineId;
            var sopId = item.sopId;
            var itemId = item.itemId;
            if (!additionalInfo[sopId]) {
                additionalInfo[sopId] = [];
            }
            if (item.isGiftCard) {
                var giftCardInfo = {};//this.state.additionalInfoOptions['giftCard'];
                giftCardInfo.fieldId = this.state.additionalInfoOptions['giftCard'].fieldId;
                giftCardInfo.value = item.giftCardNum;
                giftCardInfo.lineUniqueId = lineUniqueId;
                additionalInfo[sopId].push(giftCardInfo);
            }
            if (item.needsSerialNum) {
                var serialNumInfo = {};
                serialNumInfo.fieldId = this.state.additionalInfoOptions['serialNum'].fieldId;
                serialNumInfo.value = item.serialNum;
                serialNumInfo.lineUniqueId = lineUniqueId;
                additionalInfo[sopId].push(serialNumInfo);
            }
            var location = this.state.activeLocation.locationId;
            var inventoryDetail = [];
            for (var key in item.usedBins) {
                inventoryDetail.push(item.usedBins[key]);
            }
            pickingSummary[sopId].push({
                lineUniqueId: lineUniqueId,
                qty: qty,
                qtyCancelled: item.qtyCancelled,
                subItemInfo: item.subItemInfo,
                doSubstitution: item.doSubstitution,
                isBackordered: item.isBackordered,
                isFulfillable: item.isFulfillable,
                location: location,
                usesBins: this.state.activeLocation.usesBins && item.usesBins,
                inventoryDetail: inventoryDetail,
                itemId: itemId
                }
            )
        }
        for (var sopID in pickingSummary){
            pickingSummaryArray.push({
                sopId: sopID,
                pickedItems: pickingSummary[sopID]
            });
        }
        var postBody = {
            pickingSummary: pickingSummaryArray,
            pickCounts: this.state.pickCounts,
            emptyBins: this.state.emptyBins,
            readyToBillSOPs: SOPsToBill,
            batchId: this.state.batchId,
            additionalInfo: additionalInfo,
            nonFulfillableItems: this.state.nonFulfillableItems,
            employeeId: this.state.userId
        };
        await this.props.makeRESTCall(
            'byuwmssop',
            'post',
            postBody,
            (submitSessionData) => {
                if (submitSessionData.success && submitSessionData.failedSOP.length === 0) {
                    this.setupSummary(SOPsToBill);
                } else {
                    if (submitSessionData.success) {
                        this.setState({
                            showDialog: true,
                            dialogTitle: "Error Submitting Session",
                            dialogContent: <h1>The session failed to be submitted--{submitSessionData.message} PLEASE CONTACT I.T.</h1>,
                            isErrorMessage: true,
                            actionDialog: false
                        })
                    } else {
                        this.setState({
                            showDialog: true,
                            dialogTitle: "Unable To Submit Session",
                            dialogContent: <h1>The session failed to be submitted--{submitSessionData.message} Please submit again!</h1>,
                            actionDialog: false,
                            sucessfullySubmitted: false
                        })
                    }
                }
            },
            (title, error) => {
                this.displayError(title, error);
                this.setState({
                    sucessfullySubmitted: false
                })
            },
            () => {
                this.stopLoading();
            }
        );
    }

    setupSummary(SOPsToBill) {
        //Group Items into Ship Groups/Repick
        var slotList = this.state.slotList;
        var shipGroups = this.state.shipGroups;
        var SOPInfo = this.state.SOPInfo;
        var toteStorageObject = {};
        var toteStorageIds = [];
        var toteStorageArray = [];
        var repicks = [];
        var repickPutawayActive = true;
        var defaultShipGroupIndex;
        var pickedItems = this.state.itemsToPick;
        var handledTotes = [];
        for (var i in pickedItems) {
            var item = pickedItems[i];
            var orderTote = item.tote;
            var orderSOP = item.sopId;
            var orderSlot = slotList[orderTote];
            if (handledTotes.indexOf(orderTote) > -1) {
                continue;
            }
            if (!SOPInfo[orderSOP].SOPHasFulfillments) {
                if (item.qtyCancelled > 0 || item.isBackordered) {
                    //If the entire order is cancelled/backordered, and the tote is empty we want to clear that
                    if (!toteStorageObject[orderTote]) {
                        toteStorageObject[orderTote] = {
                            tote: orderTote,
                            slot: orderSlot,
                            orderSOP: orderSOP
                        }
                    }
                    continue;
                }
            }
            if (SOPsToBill.indexOf(orderSOP) == -1) {
                repicks.push({
                    tote: orderTote,
                    slot: orderSlot,
                    orderSOP: orderSOP,
                    priorityRank: SOPInfo[orderSOP].priorityRank
                });
                delete toteStorageObject[orderTote];
                handledTotes.push(orderTote);
            }
            else {
                repickPutawayActive = false;
                var orderShipMethod = item.shippingMethod;
                var groupFound = false;
                for (var j in shipGroups) {
                    var shipGroup = shipGroups[j];
                    if (!defaultShipGroupIndex && shipGroup.isDefault) {
                        defaultShipGroupIndex = j;
                    }
                    if (shipGroup.shipMethods.indexOf(orderShipMethod) > -1) {

                        handledTotes.push(orderTote);
                        if (!shipGroups[j].orders) {
                            shipGroups[j].orders = [];
                        }
                        shipGroups[j].orders.push({
                            tote: orderTote,
                            slot: orderSlot,
                            orderSOP: orderSOP,
                            priorityRank: SOPInfo[orderSOP].priorityRank
                        });
                        delete toteStorageObject[orderTote];
                        groupFound = true;
                        break;
                    }
                }
                if (!groupFound) {
                    if (!shipGroups[defaultShipGroupIndex].orders) {
                        shipGroups[defaultShipGroupIndex].orders = [];
                    }
                    shipGroups[defaultShipGroupIndex].orders.push({
                        tote: orderTote,
                        slot: orderSlot,
                        orderSOP: orderSOP,
                        priorityRank: SOPInfo[orderSOP].priorityRank
                    });
                    delete toteStorageObject[orderTote];
                    handledTotes.push(orderTote);
                }
            }
        }
        for (var tote in toteStorageObject) {
            toteStorageIds.push(tote);
            toteStorageArray.push(toteStorageObject[tote]);
        }

        var sessionSummaryInfo = {
            shipGroups: shipGroups,
            repicks: repicks,
            toteStorageInfo: toteStorageArray
        };
        this.setState({
            sessionSummaryInfo: sessionSummaryInfo,
            repickPutawayActive: repickPutawayActive,
            toteStorageIds: toteStorageIds
        });
        if (this.state.orderActions.length > 0) {
            this.displayOrderAction();
        }
        else {

            this.switchStage('Summary');
        }
    }

    putawayRepick() {
        this.setState({
            repickPutawayActive: true
        });
    }

    async assignRepickToSlot(e) {
        this.startLoading();
        e.preventDefault();
        var newSlot = e.target.elements.repickSlotNum.value;
        var sessionSummaryInfo = JSON.parse(JSON.stringify(this.state.sessionSummaryInfo));
        var completedRepicks = this.state.completedRepicks;
        var repick = sessionSummaryInfo.repicks.shift();
        var putBody = {
            slotId: newSlot,
            SOPId: repick.orderSOP
        }


        await this.props.makeRESTCall(
            'byusopassignslot',
            'put',
            putBody,
            (putawayRepickData) => {
                if (putawayRepickData.success) {
                    this.playSuccess();
                    document.getElementById("repickSlotNum").value = "";
                    completedRepicks.push(repick);
                    this.setState({
                        sessionSummaryInfo: sessionSummaryInfo,
                        completedRepicks: completedRepicks,
                        loading: false
                    });
                }
                else {
                    var totesList = "";
                    for (var i in sessionSummaryInfo.repicks) {
                        totesList += ", " + sessionSummaryInfo.repicks[i].tote;
                    }
                    this.displayError("There was an issue putting the Repicks Away", totesList + " were not assigned to a slot but are repicks. Please contact I.T.");
                    this.endSessionSummary();
                }
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                this.stopLoading();
            }
        )
    }

    repickPutawayBack() {
        var sessionSummaryInfo = this.state.sessionSummaryInfo;
        var completedRepicks = this.state.completedRepicks;
        var lastTote = completedRepicks.pop();
        sessionSummaryInfo.repicks.unshift(lastTote);
        this.setState({
            sessionSummaryInfo: sessionSummaryInfo,
            completedRepicks: completedRepicks
        });
    }
    

    endSessionSummary() {
        var sessionSummaryInfo = this.state.sessionSummaryInfo;
        var toteStorage = sessionSummaryInfo.toteStorageInfo;
        if (toteStorage.length > 0) {
            this.showConfirm(
                "Tote Storage",
                <ToteStorage
                    toteStorage={toteStorage}
                />,
                "Done",
                "Done",
                () => this.switchStage('Prep'),
                () => this.switchStage('Prep'),
                true
            );
            setTimeout(() => { this.clearTotes(false,this.state.toteStorageIds) }, 3000);
        }
        else {
            this.switchStage('Prep');
        }
    }

    updateLocation(event) {
        var locations = this.state.locationOptions;
        var newLocation = {};
        for (var i in locations) {
            if (locations[i].locationId === event.target.value) {
                newLocation = locations[i];
                break;
            }
        }
        this.setState({
            activeLocation: newLocation
        });
        this.focusOnInput();
    }

    updateQueue(event) {
        var queues = this.state.queues;
        var newQueue = "";
        var newQueueId = event.target.value;
        for (var i in queues) {
            if (queues[i].id === newQueueId) {
                newQueue = queues[i];
                break;
            }
        }
        var newQueueLocations = this.state.locationOptionsDict[newQueueId] ? this.state.locationOptionsDict[newQueueId] : [];
        var defaultLocation = { locationId: -1 };
        if (newQueueLocations.length == 1) {
            defaultLocation = newQueueLocations[0];
        }
        this.setState({
            queue: newQueue,          
            sortBy: newQueue.sortBy,//Later overwritten
            repick: false,
            locationOptions: newQueueLocations,
            activeLocation: defaultLocation
        });
        this.focusOnInput();
    }

    changeRepick() {
        var repick = !this.state.repick;
        var queueLocations = (this.state.locationOptionsDict && this.state.queue) ? this.state.locationOptionsDict[this.state.queue.id] : [];
        this.setState({
            repick: repick,
            locationOptions: repick ? this.state.repickLocations : queueLocations
        });
        this.focusOnInput();
    }

    async getBatchInfo() {
        await this.props.makeRESTCall(
            'byusopbatch?userId=' + this.state.userId,
            'get',
            null,
            (batchInfo) => {
                if (!batchInfo.success) {
                    this.displayError("Unable to Get Batch Info", "There was an error getting Batch Info " + batchInfo.message);
                    batchInfo = {};
                }
                if (batchInfo.oldSession) {
                    this.setState({
                        batchId: batchInfo.oldSession
                    });
                    this.showConfirm(
                        "Restore Session",
                        "An existing session has been found. Would you like to resume the session?",
                        "Restore Session",
                        "Start New Session",
                        () => this.restoreSession(batchInfo),
                        () => setTimeout(() => { this.confirmCancelBatch(batchInfo) }, 10)
                    )
                }
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                this.stopLoading();
            }
        )
    }

    confirmCancelBatch(batchInfo) {
        this.playNeedMoreInfo();
        this.showConfirm(
            "Cancel Session",
            "Are you sure you want to cancel your old session? This cannot be reversed",
            "Restore Old Session",
            "Cancel Old Session",
            () => this.restoreSession(batchInfo),
            () => this.cancelBatch()
        )
        
    }

    restoreSession(batchInfo) {
        if (batchInfo.state) {
            var newState = JSON.parse(batchInfo.state);
            //Insure dialog is off
            newState.showDialog = false;
            newState.versionNum = batchInfo.versionNum;
            this.setState(newState);
        } else {
            this.updateInstructions("Select a Location and begin");
        }
        this.focusOnInput();
    }

    cancelBatch() {
        this.cancelSession(true);
    }

    switchStage(newStage) {
        if (newStage === 'Prep') {
            this.resetState();
        }
        else if (newStage === 'Picking') {
            if (this.state.invalidTotes && this.state.invalidTotes.length > 0) {
                var invalidTotesContent = (
                    <div>
                        <h2> Invalid Totes </h2>
                        {
                            this.state.invalidTotes.map(function (invalidTote, idx) {
                                return (
                                    <div key={idx}>
                                        <h3>{invalidTote.tote} : {invalidTote.message}</h3>
                                    </div>
                                )
                            })
                        }
                        <br />
                        <br />
                    </div>
                );
                var slotList = <SlotSummary slotList={this.state.slotList} />
                var content =
                    <div>
                        {
                            invalidTotesContent
                        }
                        {
                            slotList
                        }
                    </div>
                this.setState({
                    showDialog: true,
                    dialogTitle: "Session Summary",
                    dialogContent: content,
                    isErrorMessage: false,
                    actionDialog: false
                });
            }
        }
        this.setState({
            stage: newStage,
        });
        this.focusOnInput();
    }

    displayOrderAction(goBack = false) {
        const { orderActions, itemsToPick, SOPWithToteDict, slotList } = this.state;
        const dir = goBack ? -1 : 1;

        let next = this.state.orderActionsIndex + dir;

        // walk forward/backward until we find an action with slots, or run out
        while (next >= 0 && next < orderActions.length) {
            // clone so we don't mutate state objects
            const orderAction = JSON.parse(JSON.stringify(orderActions[next]));
            const slots = [];

            for (let i = 0; i < orderAction.sopInfo.length; i++) {
                const sop = orderAction.sopInfo[i];
                const sopId = sop.sopId;
                const tote = SOPWithToteDict[sopId];
                sop.orderActionInfo.slot = slotList[tote];
                const soLineId = sop.orderActionInfo.so_line_id;
                if (soLineId) {
                    for (let j = 0; j < itemsToPick.length; j++) {
                        const it = itemsToPick[j];
                        if (it.lineId === soLineId && it.quantityPicked > 0) {
                            sop.orderActionInfo.slot_message =
                            sop.orderActionInfo.slot_message.replace("{quantity}", it.quantityPicked);
                            slots.push(slotList[tote]);
                            break; // matched this sop; move on
                        }
                    }
                }
                else {
                    slots.push(slotList[tote]);
                } 
            }

            if (slots.length > 0) {
                orderAction.slots = slots;
                this.setState(
                    { currentOrderAction: orderAction, orderActionsIndex: next },
                    () => {
                        if (this.state.stage !== "OrderActions") this.switchStage("OrderActions");
                    }
                );
                return; // done
            }

            next += dir; // keep scanning
        }

        // none found; go to summary
        this.switchStage("Summary");
    }


    pickNow(lineId) {
        var instructions = "";
        var itemsToPick = this.state.itemsToPick;
        var pickCounts = this.state.pickCounts;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId === lineId) {
                itemsToPick[i].pickLater = false;
                pickCounts.pickLater = pickCounts.pickLater - 1;
                instructions = itemsToPick[i].itemName + " pick later has been undone";
                this.setState({
                    itemsToPick: itemsToPick,
                    pickCounts: pickCounts
                });
                break;
            }
        }
        this.updateInstructions(instructions);
        this.updateState();
        this.focusOnInput();
    }

    doNotPick(lineId,doNotPickDecision) {
        var instructions = "";
        var itemsToPick = this.state.itemsToPick;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId === lineId) {
                var item = itemsToPick[i];
                var itemName = item.itemName;
                var pickCounts = this.state.pickCounts;
                instructions = itemName + " will be picked later";
                item.pickLater = true;
                pickCounts.pickLater = pickCounts.pickLater + 1;
                if (this.state.activeLocation.usesBins) {
                    itemsToPick[i] = item;
                }
                else {
                    itemsToPick.splice(i, 1);
                    itemsToPick.push(item);
                }
                this.setState({
                    itemsToPick: itemsToPick,
                    pickCounts: pickCounts
                });
                break;
            }
        }
        this.updateInstructions(instructions);
        this.updateState();
        this.focusOnInput();
    }

    backorderItem(lineId) {
        var itemsToPick = this.state.itemsToPick;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId === lineId) {
                var item = itemsToPick[i];
                var itemName = item.itemName;
                var qtyToBackorder = item.quantity;
                var itemInfo = this.state.itemInfo[item.itemId];
                var locationQtyInfo = itemInfo.locationQtyInfo;
                var hasQtyAvailable = false;
                for (var key in locationQtyInfo) {
                    if (locationQtyInfo[key].qtyOnHand > 0) {
                        hasQtyAvailable = true;
                        break;
                    }
                }
                if (hasQtyAvailable) {
                    this.showConfirm(
                        "Backorder",
                        <ItemStockInfo
                            qtyToCancel={qtyToBackorder}
                            itemName={itemName}
                            lifecycleStage={itemInfo.lifecycleStage}
                            locationQtyInfo={itemInfo.locationQtyInfo}
                        />,
                        "Don't Backorder",
                        "Yes",
                        this.focusOnInput,
                        () => { this.backorderItemCallback(i) }
                    );
                }
                else {
                    this.backorderItemCallback(i);
                }
                break;
            }
        }
    }

    backorderItemCallback(itemIndex) {
        var itemsToPick = this.state.itemsToPick;
        var item = itemsToPick[itemIndex];
        var qtyToBackorder = item.quantity;
        var itemName = item.itemName;
        item.isBackordered = true;
        item.qtyBackordered = qtyToBackorder;
        var pickCounts = this.state.pickCounts;
        pickCounts.backordered = pickCounts.backordered + item.qtyBackordered;
        item.quantity = 0;
        if (this.state.activeLocation.usesBins) {
            itemsToPick[itemIndex] = item;
        }
        else {
            itemsToPick.splice(itemIndex, 1);
            itemsToPick.push(item);
        }
        this.setState({
            itemsToPick: itemsToPick,
            pickCounts: pickCounts
        });
        var instructions = itemName + " has been backordered";
        this.updateInstructions(instructions);
        this.updateState();
        this.focusOnInput();
    }

    changeBin(lineId, previous) {
        var currBin;
        var itemsToPick = this.state.itemsToPick;
        var itemInfo = this.state.itemInfo;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId === lineId) {
                var itemInfoForItem = itemInfo[itemsToPick[i].itemId];
                var currBin = itemInfoForItem.bins[itemInfoForItem.binIndex].bin;
                break;
            }
        }
        this.setState({
            showDialog: true,
            dialogFullScreen: false,
            dialogContent: (<form className="binInput" onSubmit={(e) => this.changeBinCallback(e,lineId,previous)} >
                <label htmlFor="binNum"></label>
                <input
                    autoFocus
                    required
                    pattern={currBin + "|[Yy]"}
                    autoComplete="off"
                    type="text"
                    id="binNum"
                    name="binNum"
                />
            </form>),
            dialogTitle: <div>Scan <b>{currBin} </b> to confirm</div>,
            isErrorMessage: false,
            actionDialog: true,
            summaryActive: false
        });
    }

    changeBinCallback(e, lineId, previous) {
        e.preventDefault();
        var itemsToPick = this.state.itemsToPick;
        var itemInfo = this.state.itemInfo;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId === lineId) {
                var emptyBins = this.state.emptyBins;
                var toModifyItem = itemsToPick[i];
                var itemInfoForItem = itemInfo[toModifyItem.itemId];
                var newBinIndex = itemInfoForItem.binIndex;
                var oldBin = itemInfoForItem.bins[newBinIndex];
                var maxNumber = itemInfoForItem.bins.length - 1;
                if (previous) {
                    newBinIndex--
                }
                else {
                    newBinIndex++;
                }
                if (newBinIndex <= maxNumber && newBinIndex >= 0) {
                    var emptyBinInfo = {
                        item: itemsToPick[i].itemId,
                        bin: oldBin
                    };
                    //Don't have duplicate empty bins
                    if (
                        !emptyBins.some
                            (
                                e => (
                                    e.item === itemsToPick[i].itemId
                                    &&
                                    e.bin === oldBin
                                )
                            )
                    ) {
                        emptyBins.push(emptyBinInfo);
                    }
                }
                else {
                    newBinIndex = itemInfoForItem.binIndex;
                }
                if (newBinIndex === maxNumber) {
                    itemInfoForItem.allBinsEmpty = true;
                }
                itemInfoForItem.binIndex = newBinIndex;
                itemsToPick[i] = toModifyItem;
                itemInfo[toModifyItem.itemId] = itemInfoForItem;
                this.setState({
                    itemsToPick: itemsToPick,
                    itemInfo: itemInfo,
                    emptyBins: emptyBins
                });
                this.closeDialog();
                break;
            }
        }
        this.updateState();
        this.focusOnInput();
    }

    updateGiftCardNum(e, lineUniqueId, slotVerified=!(this.state.requireSlotScan && this.state.putawayMode)) {
        e.preventDefault();
        var updateGiftCardEvent = e;
        var itemName = "";
        const giftCardNum = e.target.elements.giftCard.value;
        var itemsToPick = this.state.itemsToPick;
        var item;
        var itemIndex;
        for (var i in itemsToPick) {
            item = itemsToPick[i];
            if (item.lineId == lineUniqueId) {
                if (!slotVerified) {
                    this.playScanSlot();
                    this.setState({
                        verifyingSlot: true,
                        showDialog: true,
                        dialogFullScreen: true,
                        dialogContent: (
                            <div>
                                <form className="verifySlot" onSubmit={(e) => { e.preventDefault(); this.closeDialog(true); this.updateGiftCardNum(updateGiftCardEvent, lineUniqueId, true) }} >
                                    <label htmlFor="slotNum"></label>
                                    <input
                                        autoFocus
                                        required
                                        pattern={item.tote}
                                        autoComplete="off"
                                        type="text"
                                        id="slotNum"
                                        name="slotNum"
                                    />
                                </form>
                                <b>Tote: {item.tote}</b>
                            </div>
                        ),
                        dialogTitle: "Scan Tote In " + item.slot,
                        isErrorMessage: false,
                        actionDialog: true,
                        summaryActive: false
                    });
                    setTimeout(this.setInvalidSlotScanEvent, 10);
                }
                else {
                    itemIndex = i;
                }
                break;
            }
        }
        //Mark it as picked
        if (slotVerified) {
            itemsToPick[itemIndex].giftCardNum = giftCardNum;
            itemsToPick[itemIndex].editGiftCard = false;
            itemName = itemsToPick[itemIndex].itemName;
            if (itemsToPick[itemIndex].quantity > 0) {
                itemsToPick[itemIndex].quantity = itemsToPick[itemIndex].quantity - 1
            }
            if (itemsToPick[itemIndex].quantity == 0) {
                var itemToPick = itemsToPick[itemIndex];
                itemsToPick.splice(itemIndex, 1);
                itemsToPick.push(itemToPick);
            }
            this.setState({
                itemsToPick: itemsToPick
            });
            this.updateState();
            this.updateInstructions(itemName + " number has been recorded: " + giftCardNum);
            this.playSuccess();
            this.focusOnInput();
        } 
    }

    addSerialNum(e, itemsToPick, itemToPick, itemIndex, locationUsesBins, scannedItem, usedBin) {
        e.preventDefault();
        const serialNum = e.target.elements.serialNum.value.toUpperCase();
        itemToPick.serialNum = serialNum;
        itemToPick.editSerialNum = false;
        console.log("ITEM TO PICK BEFORE", itemToPick);
        this.closeDialog();
        if (this.state.requireSlotScan && this.state.putawayMode) {
            this.verifySlot(itemsToPick, itemToPick, itemIndex, locationUsesBins, scannedItem, usedBin);
        }
        else {
            this.pickItem(itemsToPick, itemToPick, itemIndex, locationUsesBins, scannedItem, usedBin);
        }
    }

    updateSerialNum(e, lineUniqueId) {
        e.preventDefault();
        var newSerialNum = e.target.elements.serialNum.value;
        var itemName;
        var itemsToPick = this.state.itemsToPick;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId == lineUniqueId) {
                itemsToPick[i].serialNum = newSerialNum;
                itemsToPick[i].editSerialNum = false;
                itemName = itemsToPick[i].itemName;
                this.playSuccess();
                this.updateInstructions(itemName + " Serial Number has been updated: " + newSerialNum);
                this.setState({
                    itemsToPick: itemsToPick
                });
                break;
            }
        }
    }

    updateQuantity(item) {
        var itemsToPick = this.state.itemsToPick;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId == item.lineId) {
                itemsToPick[i] = item;
                this.setState({
                    itemsToPick: itemsToPick
                });
                break;
            }
        }
        this.updateState();
    }

    startBinQtyEdit(lineUniqueId) {
        var itemsToPick = this.state.itemsToPick;
        var locationUsesBins = this.state.activeLocation.usesBins;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId == lineUniqueId) {
                var item = itemsToPick[i];
                console.log("ITEM", item);
                var itemInfo = this.state.itemInfo[item.itemId];
                var binIndex = itemInfo.binIndex;
                var binInfo = itemInfo.bins[binIndex];
                var binId = binInfo.binId;
                var usedBins = item.usedBins;
                var usedBinInfo = usedBins[binId];
                if ((locationUsesBins && !usedBinInfo) || item.quantityPicked == 0) {
                    var message = "You need to scan at least one item before you can edit the quantities.";
                    if (locationUsesBins && itemInfo.bins.length > 1) {
                        message = "You need to scan at least one item from a particular bin before you can edit that bin's qty.";
                    }
                    alert(message);
                }
                else {
                    if (!usedBinInfo) {
                        usedBinInfo = {};
                    }
                    this.showConfirm(
                        "Qty Edit",
                        <QtyEdit
                            binInfo={binInfo}
                            usedBin={usedBinInfo}
                            item={item}
                            updateQuantityWBins={this.updateQuantityWBins}
                            updateQuantity={this.updateQuantity}
                            useBins={locationUsesBins}
                        />,
                        "Finished",
                        "Finished",
                        () => { },
                        () => { this.updateState(); },
                        true
                    );
                }
            }
        }
    }

    updateQuantityWBins(lineUniqueId, usedBinInfo, binId, binInfo, qtyChange) {
        var itemsToPick = this.state.itemsToPick;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId == lineUniqueId) {
                itemsToPick[i].quantityPicked += qtyChange;
                itemsToPick[i].quantity -= qtyChange;
                itemsToPick[i].usedBins[binId] = usedBinInfo;
                var itemId = itemsToPick[i].itemId;
                var itemInfo = this.state.itemInfo;
                var binIndex = itemInfo[itemId].binIndex;
                itemInfo[itemId].bins[binIndex] = binInfo;
                this.setState({
                    itemsToPick: itemsToPick,
                    itemInfo: itemInfo
                });
                break;
            }
        }
    }

    editInputField(type, lineUniqueId) {
        var itemsToPick = this.state.itemsToPick;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId == lineUniqueId) {
                if (type == "gc") {
                    itemsToPick[i].editGiftCard = true;
                }
                else {
                    itemsToPick[i].editSerialNum = true;
                }
                this.setState({
                    itemsToPick: itemsToPick
                });
                break;
            }
        }
    }

    changeZone(selectedZone) {
        this.setState({
            activeZone: selectedZone
        });
        this.focusOnInput();
        this.updateState();
    }

    changePutawayMode() {
        console.log("HERE I AM");
        var currPutawayMode = this.state.putawayMode;
        this.setState({
            putawayMode: !currPutawayMode
        });
        this.focusOnInput();
    }

    sortItems(itemsToPick, itemInfo, sortBy) {
        if (this.state.activeLocation.usesBins) {
            itemsToPick.sort(function (a, b) {
                var itemInfoA = itemInfo[a.itemId];
                var itemInfoB = itemInfo[b.itemId];
                var activeBinA = itemInfoA.bins[itemInfoA.binIndex].bin;
                var activeBinB = itemInfoB.bins[itemInfoB.binIndex].bin;
                if (activeBinA === activeBinB) {
                    if (a.slot === b.slot) {
                        return (a.lineId < b.lineId) ? 1 : -1
                    }
                    else {
                        return (a.slot < b.slot) ? 1 : -1
                    } 
                }
                else {
                    return (activeBinA < activeBinB) ? 1 : -1
                }
            });
        }
        else {
            itemsToPick.sort(function (a, b) {
                var itemInfoA = itemInfo[a.itemId][sortBy];
                var itemInfoB = itemInfo[b.itemId][sortBy];
                //if its a string convert to lowercase for sorting
                if (typeof itemInfoA === 'string') {
                    itemInfoA = itemInfoA.toLowerCase();
                }
                if (typeof itemInfoB === 'string') {
                    itemInfoB = itemInfoB.toLowerCase();
                }
                if (itemInfoA === itemInfoB) {
                    if (a.slot === b.slot) {
                        return (a.lineId < b.lineId) ? 1 : -1
                    }
                    else {
                        return (a.slot > b.slot) ? 1 : -1
                    } 
                }
                else {
                    return (itemInfoA > itemInfoB) ? 1 : -1
                }
            });
        }
        return itemsToPick;
    }

    cancelItem(lineId) {
        var itemsToPick = this.state.itemsToPick;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId === lineId) {
                var item = itemsToPick[i];
                var itemName = item.itemName;
                var qtyToCancel = item.quantity;
                var itemInfo = this.state.itemInfo[item.itemId];
                this.showConfirm(
                    "Cancel",
                    <ItemStockInfo
                        qtyToCancel={qtyToCancel}
                        itemName={itemName}
                        lifecycleStage={itemInfo.lifecycleStage}
                        locationQtyInfo={itemInfo.locationQtyInfo}
                    />,
                    "Don't Cancel",
                    "Yes",
                    this.focusOnInput,
                    () => {this.cancelItemCallback(i)}   
                );
                break;
            }
        }
    }

    cancelItemCallback(itemIndex) {
        var itemsToPick = this.state.itemsToPick;
        var item = itemsToPick[itemIndex];
        var qtyToCancel = item.quantity;
        var itemName = item.itemName;
        item.qtyCancelled = qtyToCancel;
        var pickCounts = this.state.pickCounts;
        pickCounts.cancelled = pickCounts.cancelled + qtyToCancel;
        item.quantity = 0;
        if (this.state.activeLocation.usesBins) {
            itemsToPick[itemIndex] = item;
        }
        else {
            itemsToPick.splice(itemIndex, 1);
            itemsToPick.push(item);
        }
        this.setState({
            itemsToPick: itemsToPick,
            pickCounts: pickCounts
        });
        var instructions = qtyToCancel + " " + itemName + " have been canceled";
        this.updateInstructions(instructions);
        this.updateState();
        this.focusOnInput();
    }

    undoCancel(lineId) {
        var itemsToPick = this.state.itemsToPick;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId === lineId) {
                var item = itemsToPick[i];
                item.quantity = item.qtyCancelled;
                var pickCounts = this.state.pickCounts;
                pickCounts.cancelled = pickCounts.cancelled - item.qtyCancelled;
                item.qtyCancelled = 0;
                itemsToPick[i] = item;
                this.setState({
                    itemsToPick: itemsToPick,
                    pickCounts: pickCounts
                });
                var instructions = "Cancel has been undone";
                this.updateInstructions(instructions);
                this.updateState();
                this.focusOnInput();
                break;
            }
        }
    }

    undoBackorder(lineId) {
        var itemsToPick = this.state.itemsToPick;
        for (var i in itemsToPick) {
            if (itemsToPick[i].lineId === lineId) {
                var item = itemsToPick[i];
                item.isBackordered = false;
                item.quantity = item.qtyBackordered;
                var pickCounts = this.state.pickCounts;
                pickCounts.backordered = pickCounts.backordered - item.qtyBackordered;
                item.qtyBackordered = 0;
                itemsToPick[i] = item;
                this.setState({
                    itemsToPick: itemsToPick,
                    pickCounts: pickCounts
                });
                var instructions = "Backorder has been undone";
                this.updateInstructions(instructions);
                this.updateState();
                this.focusOnInput();
                break;
            }
        }
    }

    async getSessionOptions() {
        await this.props.makeRESTCall(
            'byusopnetsuitesessionoptions',
            'get',
            null,
            (sessionData) => {
                if (sessionData.success) {
                    console.log("SESSION DATA", sessionData);
                    this.setState({
                        requireSlotScan: sessionData.requireSlotScan,
                        multiScanThreshold: sessionData.multiScanThreshold,
                        putawayMode: sessionData.requireSlotScan,
                        locationOptionsDict: sessionData.locations,
                        repickLocations: sessionData.repickLocations,
                        queues: sessionData.activeQueues,
                        additionalInfoOptions: sessionData.additionalInfo,
                        repickList: sessionData.repickList,
                        shipGroups: sessionData.shipGroups,
                        loading: false
                    });
                    this.focusOnInput();
                } else {
                    this.displayError("Error Starting Session", "There was an error loading the session, please contact I.T.");
                }
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                this.stopLoading();
            }
        )
    }

    cancelSessionConfirm(doNotConfirm = false) {
        if (doNotConfirm) {
            this.cancelSession();
        }
        else {
            this.showConfirm(
                "Cancel Session",
                "Are you sure you want to cancel this session? All progress will be lost. If you are unable to finish but want to save what you have done, just submit instead",
                "Cancel Session",
                "Keep Picking",
                this.cancelSession,
                this.focusOnInput
            );
        }
    }

    async cancelSession() {
        this.startLoading();
        var putBody = {
            batchId: this.state.batchId
        };
        await this.props.makeRESTCall(
            'byuwmssop',
            'put',
            putBody,
            (cancelSessionData) => {
                if (cancelSessionData.success) {
                    this.switchStage('Prep');
                }
                else {
                    this.displayError("Unable to Cancel Session", "There was an error trying to cancel this session. " + cancelSessionData.message + " Please try again, or contact I.T.");
                }
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                this.stopLoading();
            }
        );
    }

    undoPick(putawayItemInfo) {
        console.log(putawayItemInfo);
        let message = "Would you like to undo picking " + putawayItemInfo.item;
        if (putawayItemInfo.usedBin && putawayItemInfo.usedBin != "none") {
            message += " from bin " + putawayItemInfo.binText
        }
        message += "?";
        this.showConfirm(
            "Undo Pick",
            message,
            "Yes",
            "No",
            () => { this.undoPickCallback(putawayItemInfo) },
            () => {  }
        );
    }

    undoPickCallback(putawayItemInfo) {
        //Find item in picked items and reverse quantity, then remove from putaway list
        var itemsToPick = this.state.itemsToPick;
        var itemInfo = this.state.itemInfo;
        console.log(itemsToPick);
        for (var i in itemsToPick) {
            if (itemsToPick[i].itemId == putawayItemInfo.itemId && itemsToPick[i].slot == putawayItemInfo.slot) {
                var item = itemsToPick[i];
                item.quantity++;
                item.quantityPicked--;
                if (putawayItemInfo.usedBin) {
                    var usedBins = item.usedBins;
                    for (const binId in usedBins) {
                        if (binId == putawayItemInfo.usedBin) {
                            usedBins[binId].qty--;
                            if (usedBins[binId].qty == 0) {
                                delete usedBins[binId];
                            }
                            break;
                        }
                    }
                    var pickedItemInfo = itemInfo[putawayItemInfo.itemId];
                    for (const binId in pickedItemInfo.bins) {
                        if (pickedItemInfo.bins[binId].binId == putawayItemInfo.usedBin) {
                            pickedItemInfo.bins[binId].onHand++;
                            break;
                        }
                    }
                }
                //Move item to the beginning of the list
                itemsToPick.splice(i, 1);
                itemsToPick.unshift(item);
                break;
            }
        }
        var scannedItemsCart = this.state.scannedItemsCart;
        for (var i in scannedItemsCart) {
            if (scannedItemsCart[i].itemId == putawayItemInfo.itemId && scannedItemsCart[i].slot == putawayItemInfo.slot) {
                scannedItemsCart.splice(i, 1);
                break;
            }
        }
        this.setState({
            itemsToPick: itemsToPick,
            itemInfo: itemInfo,
            scannedItemsCart: scannedItemsCart,
            instructions: "Pick of " + putawayItemInfo.item + " for " + (putawayItemInfo.binText ?? putawayItemInfo.slot ) + " has been undone"
        });
        this.playSuccess();
        this.updateState();
    }

    startPutAway() {
        this.setState({
            pickFromScannedItemsCart: true
        });
        this.focusOnInput();
    }

    endPutAway() {
        this.setState({
            pickFromScannedItemsCart: false
        });
        this.focusOnInput();
    }

    flipOrder() {
        this.setState({
            reverseSort: !this.state.reverseSort
        });
    }

    changeSortBy() {
        var sortByFields = this.state.sortByFields;
        var sortBy = this.state.sortBy;
        var sortByIndex = sortByFields.indexOf(sortBy);
        sortByIndex = sortByIndex + 1;
        if (sortByIndex == sortByFields.length) {
            sortByIndex = 0;
        }
        this.setState({
            sortBy: sortByFields[sortByIndex],
            itemsToPick: this.sortItems(this.state.itemsToPick, this.state.itemInfo, sortByFields[sortByIndex])
        })
    }

    

    toggleSortByLength(item) {
        var itemInfo = this.state.itemInfo;
        itemInfo[item].showShortSortBy = !itemInfo[item].showShortSortBy;
        this.setState({
            itemInfo: itemInfo
        });
    }

    playFailure() {
        const audioElbadISBN = document.getElementsByClassName("audio-element-failure")[0];
        if (audioElbadISBN.paused) {
            audioElbadISBN.play();
        } else {
            audioElbadISBN.currentTime = 0
        }
    }

    playSuccess() {
        const audioEl = document.getElementsByClassName("audio-element")[0];
        if (audioEl.paused) {
            audioEl.play();
        } else {
            audioEl.currentTime = 0
        }
    }

    playScanSlot() {
        const audioEl = document.getElementsByClassName("audio-element-scan-slot")[0];
        if (audioEl.paused) {
            audioEl.play();
        } else {
            audioEl.currentTime = 0
        }
    }

    playNeedMoreInfo() {
        const audioElNeedInfo = document.getElementsByClassName("audio-element-mi")[0];
        if (audioElNeedInfo.paused) {
            audioElNeedInfo.play();
        } else {
            audioElNeedInfo.currentTime = 0
        }
    }

    closeDialog(slotVerified = false) {
        console.log("CLOSING DIALOG", this.state);
        console.log("SLOT VERIFIED", slotVerified);
        console.log("HERE", this.state.verifyingSlot && !slotVerified)
        if (this.state.verifyingSlot && slotVerified != true){
            this.updateInstructions("Slot not Verified");
            this.playFailure();
            this.setState({
                verifyingSlot: false,
                scannedItemInput: ""
            });
        }
        if (this.state.summaryActive) {
            this.switchStage('Prep');
        }
        this.setState({
            showDialog: false
        });
        if (this.state.badSession) {
            window.location.reload();
        }
        setTimeout(this.focusOnInput, 10);
    }

    startLoading() {
        this.setState({
            loading: true
        });
    }

    stopLoading() {
        this.setState({
            loading: false
        });
        this.focusOnInput();
    }

    render() {
        return (
            <div>
                <Audio />
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    actionDialog={this.state.actionDialog}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                {
                    this.state.loading && <Loader />
                }
                {
                    !this.state.badSession &&
                    <div>
                        {
                            this.state.stage === 'Prep'
                            &&
                            <SessionPrep
                                batchId={this.state.batchId}
                                instructions={this.state.instructions}
                                updateScanTote={this.updateScanTote}
                                addScannedTote={this.addScannedTote}
                                scannedToteInput={this.state.scannedToteInput}
                                totes={this.state.sessionTotes}
                                slotList={this.state.slotList}
                                submitTotes={this.submitTotes}
                                location={this.state.activeLocation}
                                locations={this.state.locationOptions}
                                queue={this.state.queue}
                                queues={this.state.queues}
                                repickList={this.state.repickList}
                                updateLocation={this.updateLocation}
                                updateQueue={this.updateQueue}
                                repick={this.state.repick}
                                changeRepick={this.changeRepick}
                                removeScannedTote={this.removeScannedTote}
                                removeAllScannedTotes={this.removeAllScannedTotes}
                                updateBatchSource={this.updateBatchSource}
                                loading={this.state.loading}
                                userPermissions={this.state.userPermissions}
                            />
                        }
                        {
                            this.state.stage === 'Picking'
                            &&
                            <GMPicking
                                    requireSlotScan={this.state.requireSlotScan}
                                    multiScanThreshold={this.state.multiScanThreshold}
                                    putawayMode={this.state.putawayMode}
                                    changePutawayMode={this.changePutawayMode}
                                    instructions={this.state.instructions}
                                    activeSlot={this.state.activeSlot}
                                    location={this.state.activeLocation}
                                    locations={this.state.locations}
                                    switchStage={this.switchStage}
                                    salesOrders={this.state.salesOrders}
                                    itemsToPick={this.state.itemsToPick}
                                    scannedItemsCart={this.state.scannedItemsCart}
                                    pickFromScannedItemsCart={this.state.pickFromScannedItemsCart}
                                    startPutAway={this.startPutAway}
                                    endPutAway={this.endPutAway}
                                    itemInfo={this.state.itemInfo}
                                    loading={this.state.loading}
                                    slotList={this.state.slotList}
                                    updateScanItem={this.updateScanItem}
                                    processGMPickingInput={this.processGMPickingInput}
                                    doNotPick={this.doNotPick}
                                    backorderItem={this.backorderItem}
                                    pickNow={this.pickNow}
                                    changeBin={this.changeBin}
                                    submitPicking={this.checkPutawayCart}
                                    changeZone={this.changeZone}
                                    cancelSession={this.cancelSessionConfirm}
                                    showImage={this.showImage}
                                    scannedItemInput={this.state.scannedItemInput}
                                    activeZone={this.state.activeZone}
                                    sortItems={this.sortItems}
                                    additionalInfoOptions={this.state.additionalInfoOptions}
                                    updateGiftCardNum={this.updateGiftCardNum}
                                    updateSerialNum={this.updateSerialNum}
                                    editInputField={this.editInputField}
                                    updateQuantity={this.updateQuantity}
                                    canCancel={this.state.userPermissions.indexOf(this.state.appPermissions.CANCEL_ITEM) > -1}
                                    canBackorder={this.state.userPermissions.indexOf(this.state.appPermissions.BACKORDER_ITEM) > -1}
                                    canEditQty={this.state.userPermissions.indexOf(this.state.appPermissions.EDIT_PICK_QTY) > -1 }
                                    cancelItem={this.cancelItem}
                                    undoCancel={this.undoCancel}
                                    undoBackorder={this.undoBackorder}
                                    reverseSort={this.state.reverseSort}
                                    flipOrder={this.flipOrder}
                                    sortBy={this.state.sortBy}
                                    sortByFields={this.state.sortByFields}
                                    changeSortBy={this.changeSortBy}
                                    toggleSortByLength={this.toggleSortByLength}
                                    startBinQtyEdit={this.startBinQtyEdit}
                                    undoPick={this.undoPick}
                            />
                        }
                        {
                            this.state.stage === 'OrderActions' && this.state.currentOrderAction
                            &&
                            <OrderAction
                                currentOrderAction={this.state.currentOrderAction}
                                displayOrderAction={this.displayOrderAction}
                                orderActionsIndex={this.state.orderActionsIndex}
                            />
                        }
                        {
                            this.state.stage === 'Summary'
                            &&
                            <SessionSummary
                                sessionSummaryInfo={this.state.sessionSummaryInfo}
                                repickPutawayActive={this.state.repickPutawayActive}
                                putawayRepick={this.putawayRepick}
                                assignRepickToSlot={this.assignRepickToSlot}
                                repickPutawayBack={this.repickPutawayBack}
                                completedRepicks={this.state.completedRepicks}
                                endSessionSummary={this.endSessionSummary}
                                orderActions={this.state.orderActions}
                                loading={this.state.loading}
                            />
                        }
                    </div>
                }
            </div>
        );
    }
}
